import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroupRow } from './GroupRow';

class PatientCareCenterNoteChargesGroupPhysPerfTest extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div>
                    <div className={styles.row}>
                        <span className={styles.col1} >
                            <b>Physical Performance Test or Measurement</b>
                        </span>
                        <span className={styles.col2}>
                            <div className={styles.int_field}>
                            </div>
                        </span>
                    </div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const act = this.props.activities[key];
                            return (
                                <PatientCareCenterNoteChargesGroupRow
                                    key={act.id}
                                    id={act.id}
                                    table='MLSPECIALTYTESTS'
                                    prefix='XLSZ'
                                    noteId={this.props.noteId}
                                    activity={act.activity}
                                    selected={act.selected}
                                />

                            )
                        })
                    }

                </div>
            );
        } else {
            return (<span />);
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let activities = Object.keys(state.entities.notes.MLSPECIALTYTESTS)
        .filter(key => {
            return (state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === xlno &&
                state.entities.notes.MLSPECIALTYTESTS[key].XLSZPERFORMED === true)
        })
        .sort((a, b) => state.entities.notes.MLSPECIALTYTESTS[a].XLSZNO - state.entities.notes.MLSPECIALTYTESTS[b].XLSZNO)
        .map(key => {
            let act = state.entities.notes.MLSPECIALTYTESTS[key].XLSZMDNO ?
                state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[state.entities.notes.MLSPECIALTYTESTS[key].XLSZMDNO].SZNAME + ' - ' +
                state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[state.entities.notes.MLSPECIALTYTESTS[key].XLSZMDNO].SZCODE + ' - ' : '<Activity Not Defined> - ';
            act += state.entities.notes.MLSPECIALTYTESTS[key].XLSZACTIVITY ?
                ' - ' + state.entities.notes.MLSPECIALTYTESTS[key].XLSZACTIVITY : '';
            return {
                activity: act,
                id: state.entities.notes.MLSPECIALTYTESTS[key].XLSZNO,
                selected: state.entities.notes.MLSPECIALTYTESTS[key].XLSZISGROUP
            };
        });


    return {
        noteId,
        noteType,
        xlno,
        activities
    };
}

const connectedPatientCareCenterNoteChargesGroupPhysPerfTest = connect(mapStateToProps)(PatientCareCenterNoteChargesGroupPhysPerfTest);
export { connectedPatientCareCenterNoteChargesGroupPhysPerfTest as PatientCareCenterNoteChargesGroupPhysPerfTest };

